// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2MNju","head":"Table_head__3oSOE","col":"Table_col__1NMmk"};